/**
 * i18n設定モジュール
 *
 * i18next + react-i18nextを使用した国際化対応
 * - デフォルト言語: 日本語 (ja)
 * - 名前空間: translationJa (共通翻訳), zod (バリデーションエラーメッセージ)
 */

import i18next, { type InitOptions, type Resource } from 'i18next';
import { initReactI18next } from 'react-i18next';
import { z } from 'zod';
import { customErrorMap } from './error-map';
import translationJa from './locales/ja/translation.json5';
import zodJa from './locales/ja/zod.json';
import type { AppNamespace } from './types';

const DEFAULT_LANGUAGE = 'ja';

export const resources = {
  ja: {
    translation: translationJa,
    zod: zodJa,
  },
} satisfies Resource;

const namespaces = Object.keys(resources.ja) as AppNamespace[];

const initOptions: InitOptions = {
  lng: DEFAULT_LANGUAGE,
  fallbackLng: DEFAULT_LANGUAGE,
  resources,
  defaultNS: 'translation',
  ns: namespaces,
  interpolation: {
    escapeValue: false,
  },
  returnNull: false,
};

if (!i18next.isInitialized) {
  void i18next.use(initReactI18next).init(initOptions);
}

z.config({ customError: customErrorMap });

export const i18n = i18next;
export { customErrorMap } from './error-map';
export type {
  AppLanguage,
  AppNamespace,
  TypedUseTranslationOptions,
  TypedUseTranslationResponse,
} from './types';
